import React from 'react';
import { Button } from '../Button';

export interface InputProps {
  label?: string;
  id: string;
  name: string;
  type: string;
  placeholder: string;
  setValue?: React.Dispatch<React.SetStateAction<string | null>>;
  defaultValue?: string;
  disabled?: boolean;
  value?: string;
  className?: string;
  button?: {
    text: string;
    onClick: () => void | Promise<void>;
    disabled?: boolean;
  };
}

export const Input = (props: InputProps) => {
  return (
    <div>
      {props.label && (
        <label htmlFor={props.id} className="block text-sm/6 font-medium text-main mt-6">
          {props.label}
        </label>
      )}
      <div className="mt-2 sm:flex sm:items-center">
        <div className="w-full min-w-0">
          <input
            disabled={props.disabled}
            id={props.id}
            name={props.name}
            type={props.type}
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            value={props.value}
            onChange={(event) => {
              if (props.setValue) {
                props.setValue(event.target.value);
              }
            }}
            className={
              `block w-full rounded-md bg-surface px-3 py-1.5 text-base
           text-main outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-disabled
           focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-brand
           disabled:cursor-not-allowed disabled:bg-subtle disabled:text-disabled
           disabled:outline-gray-200 sm:text-sm/6 ` + (props.className ?? '')
            }
          />
        </div>
        {props.button && (
          <Button
            variant="primary"
            size="md"
            disabled={props.button.disabled}
            onClick={props.button.onClick}
            className="w-full sm:ml-3 sm:mt-0 sm:w-auto"
          >
            {props.button.text}
          </Button>
        )}
      </div>
    </div>
  );
};
